export const PAGE_PATH = '/fortuna/list';
